import { combineReducers } from 'redux';
import { toggleMoreModal, togglePaymentModal, toggleSettingsModal, switchCurrentDevice } from '../components/Modal/actions';
import { logoutButtonClick } from '../components/Auth/actions';
import { editGeozoneClicked, toggleGeozoneEditor } from '../components/Modal/GeozonesModal/actions';
import {createGeozone, updateGeozoneFinished} from '../sagas/geozones/actions';

const moreModalOpened = (state = false, action) => {
  if (action.type === toggleMoreModal.type) {
    return !state;
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  return state;
};

const settingsModalOpened = (state = false, action) => {
  if (action.type === toggleSettingsModal.type) {
    return !state;
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  return state;
};

const createGeozoneOpened = (state = false, action) => {
  if (action.type === editGeozoneClicked.type) {
    return true;
  }
  if (action.type === switchCurrentDevice.type) {
    return false;
  }
  if (action.type === toggleSettingsModal.type) {
    return false;
  }

  if(action.type === updateGeozoneFinished.done.type) {
    return false;
  }

  if (action.type === createGeozone.done.type) {
    return false;
  }

  if (action.type === toggleGeozoneEditor.type) {
    return !state;
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  return state;
};

const paymentsModalOpened = (state = false, action) => {
  if (action.type === togglePaymentModal.type) {
    return !state;
  }

  if (action.type === logoutButtonClick.type) {
    return false;
  }

  return state;
};

const currentDeviceId = (state = null, action) => {
  if (action.type === toggleSettingsModal.type) {
    return action.payload.deviceId || state;
  }

  return state;
};

export default combineReducers({
  moreModalOpened,
  settingsModalOpened,
  paymentsModalOpened,
  currentDeviceId,
  createGeozoneOpened,
});



// WEBPACK FOOTER //
// ./src/reducers/modal.js